export default "__VITE_ASSET__BC6507dl__"